import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { deleteColumnAC } from "store/actions/condition";
import ConfirmActionModal from "components/modals/ConfirmActionModal";
import ConditionModal from "components/modals/ConditionModal";
import { ModalContext } from "components/ModalContext";
import useSetting from "components/sidebarComponents/SidebarProject/use-settings";

export const useConditionModal = ({ tableId }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { handleModal } = useContext(ModalContext);

  const handleCancel = () => handleModal(null, true);

  const {removeTableColumn} = useSetting()

  const onShowConditionModal = ({
    columnScheme: {
      newColumnName: columnName,
      newColumnKey: columnKey,
      currentTree: tree,
      functionValue,
      currentTabId,
    } = {},
    isEdit = false,
    autoActiveInputs = true,
  }) => {
    const showColumnDeletePopUp = () => {
      const deleteCallback = () => {
        dispatch(deleteColumnAC(columnKey, tableId));
        removeTableColumn(columnKey)
        handleCancel();
      };

      handleModal(
        <ConfirmActionModal
          title={t('delete_function')}
          description={
            <>
              {t('delete_the_column')} <span>{columnName}</span>?
            </>
          }
          confirmButtonText={t('yes_delete')}
          confirmCallback={deleteCallback}
          onClose={handleCancel}
        />
      );
    };

    handleModal(
      <ConditionModal
        isEdit={isEdit}
        currentTableId={tableId}
        deleteCallback={showColumnDeletePopUp}
        currentTabId={currentTabId}
        autoActiveInputs={autoActiveInputs}
        functionValue={functionValue}
        columnKey={columnKey}
        columnName={columnName}
        onClose={handleCancel}
        tree={tree}
      />,
      false,
      true
    );
  };

  return onShowConditionModal;
};
